<template>
    <v-col cols="12" xl="10" class="py-10 px-0">
        <v-row>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.technician_name"
                    :label="t('pharmacy-groups::form.label.technician_name')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.technician_name"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.technician_phone"
                    :label="t('pharmacy-groups::form.label.technician_phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.technician_phone"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.technician_fax"
                    :label="t('pharmacy-groups::form.label.technician_fax')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.technician_fax"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.technician_email"
                    :label="t('pharmacy-groups::form.label.technician_email')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.technician_email"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.technician_rpsgb_number"
                    :label="t('pharmacy-groups::form.label.technician_rpsgb_number')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.technician_rpsgb_number"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            readOnlyRules: !this.can('api.v1.pharmacy-groups.update') && this.can('api.v1.pharmacy-groups.show'),
            validationRules: {
                technician_name: [(v) => !!v || t('users::validation.field.required')],
                technician_phone: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.phone],
                technician_fax: [this.$root.rules.fax],
                technician_email: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
                technician_rpsgb_number: [(v) => !!v || t('users::validation.field.required')],
            },
        };
    },
};
</script>

<style></style>
